$(() => {
  // Define these changes separately because we only want them to fire when product options
  // are clicked. We don't want them firing on every pageload.
  const toggle_dependencies = () => {
    const fade = 400;
    const provider = $('#product-provider-checkbox');
    const directory = $('#product-directory-checkbox');

    const dependencies = [
      // User inputs
      { element: $('#med-staff-ftes-wrapper'), checkboxes: [provider] },
      { element: $('#time-on-credentialing-wrapper'), checkboxes: [provider] },
      { element: $('#hospitals-in-system-wrapper'), checkboxes: [provider] },
      { element: $('#calls-per-year-wrapper'), checkboxes: [directory] },
      { element: $('#cost-per-call-wrapper'), checkboxes: [directory] },
      { element: $('#avg-credentialing-time-wrapper'), checkboxes: [provider] },
      { element: $('#pt-discharges-per-year-wrapper'), checkboxes: [directory] },
      { element: $('#outpt-visits-per-year-wrapper'), checkboxes: [directory] },
      { element: $('#net-pt-revenue-wrapper'), checkboxes: [directory] },

      // Benchmark inputs
      { element: $('#hr-enrolling-providers-wrapper'), checkboxes: [provider] },
      { element: $('#hr-in-committee-mtg-wrapper'), checkboxes: [provider] },
      { element: $('#fte-in-committee-mtg-wrapper'), checkboxes: [provider] },
      { element: $('#time-preparing-for-mtg-wrapper'), checkboxes: [provider] },
      { element: $('#min-adding-to-ehr-wrapper'), checkboxes: [directory] },
      { element: $('#providers-added-per-yr-wrapper'), checkboxes: [directory] },
      { element: $('#daily-revenue-per-provider-wrapper'), checkboxes: [provider] },
      { element: $('#providers-credentialed-per-month-wrapper'), checkboxes: [provider] },
      { element: $('#annual-committee-member-salary-wrapper'), checkboxes: [provider] },

      // Benefits
      { element: $('.reduce-time-credentialing'), checkboxes: [provider] },
      { element: $('.reduce-time-committee-review'), checkboxes: [provider] },
      { element: $('.reduce-time-enrolling-providers'), checkboxes: [provider] },
      { element: $('.reduce-time-adding-to-ehr'), checkboxes: [directory] },
      { element: $('.reduce-call-volume'), checkboxes: [directory] },
      { element: $('.increase-revenue'), checkboxes: [provider] },
      { element: $('.improve-pt-acquisition'), checkboxes: [directory] },
      { element: $('.reduce-pt-leakage'), checkboxes: [directory] },

      // Investment
      { element: $('#provider-implementation-fee-wrapper'), checkboxes: [provider] },
      { element: $('#provider-license-fee-wrapper'), checkboxes: [provider] },
      { element: $('#directory-implementation-fee-wrapper'), checkboxes: [directory] },
      { element: $('#directory-license-fee-wrapper'), checkboxes: [directory] },
    ];

    dependencies.forEach((dependency) => {
      const checked = dependency.checkboxes.filter(($checkbox) => $checkbox.is(':checked'));

      if (checked.length > 0) {
        dependency.element.slideDown(fade);
      } else {
        dependency.element.slideUp(fade);
      }
    });
  };

  $('.product-options').click(() => {
    toggle_dependencies();
  });

  toggle_dependencies();
});
